module.exports = __webpack_public_path__ + "img/friday-schedule.ddbaa25e.png";